import React, { useEffect } from "react";
import { useField } from "react-final-form";
import { required, TextInput } from "react-admin";

interface ICommercialDocumentNoteInput {
  index: number;
  ccaRateChartId: any;
}

const CommercialDocumentNoteInput = ({
  index,
  ccaRateChartId,
}: ICommercialDocumentNoteInput) => {
  const noteField = useField(`commercialDocumentNotes[${index}].note`);
  const rateChartField = useField(
    `commercialDocumentNotes[${index}].ccaRateChartId`
  );

  useEffect(() => {
    noteField.input.onChange(null);
    rateChartField.input.onChange(ccaRateChartId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TextInput
      label="Note"
      source={`commercialDocumentNotes[${index}].note`}
      onChange={(e: any) => {
        rateChartField.input.onChange(ccaRateChartId);
      }}
      validate={required()}
    />
  );
};

export default CommercialDocumentNoteInput;
